// Description: This component render an Alert when the user do something
// Update: 09/07/2025

// React Components and DOM Elements
import React, { useEffect, useState } from 'react'

// Material UI Components
import { Alert as MuiAlert, Box, Portal } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';

const normalizeSeverityByType = (type) => {
  const value = String(type || '').toLowerCase();

  switch (value) {
    case 'success':
      return 'success';
    case 'alert':
    case 'warning':
      return 'warning';
    case 'error':
      return 'error';
    case 'download':
    case 'info':
    default:
      return 'info';
  }
};

const renderMessage = (message) => {
  if (React.isValidElement(message)) {
    return message;
  }

  return <span dangerouslySetInnerHTML={{ __html: String(message || '') }} />;
};

// Render Your Component
const CustomAlert = ({ type, message, right }) => {
  // State variables
  const [isMainContentCollapsed, setIsMainContentCollapsed] = useState(false);

  // Effect to check if the sidebar is collapsed or not
  useEffect(() => {
    const mainContent = document.querySelector('.MainContent');
    if (mainContent) {
      setIsMainContentCollapsed(mainContent.classList.contains('collapsed'));
    }
  }, []);

  const severity = normalizeSeverityByType(type);

  const positionStyles = right
    ? {
      top: "23px",
      left: "50%",
      transform: "translateX(-50%)",
    }
    : {
      bottom: "20px",
      left: isMainContentCollapsed ? "100px" : "320px",
    };

  return (
    <Portal>
      <Box sx={{
        maxWidth: '100vw',
        position: 'fixed',
        zIndex: 9999,
        ...positionStyles
      }}>
        <MuiAlert
          severity={severity}
          variant='standard'
          icon={<CheckCircleOutline fontSize='inherit' />}
          sx={{ width: '100%' }}
        >
          {renderMessage(message)}
        </MuiAlert>
      </Box>
    </Portal>
  )
}

export default CustomAlert
